import { Switch as MuiSwitch, SwitchProps } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'
import { forwardRef } from 'react'

import colors from '../../../../theme/colors'

const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.petrol,
    '&:hover': {
      backgroundColor: alpha(colors.petrol, theme.palette.action.hoverOpacity)
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.petrol
  }
}))

type CustomSwitchProps = SwitchProps & {
  small?: boolean
}

export const CustomSwitch = forwardRef<HTMLButtonElement, CustomSwitchProps>(
  ({ small = false, ...props }, ref) => {
    return small ? (
      <StyledSwitch disableRipple size="small" ref={ref} {...props} />
    ) : (
      <StyledSwitch disableRipple ref={ref} {...props} />
    )
  }
)

CustomSwitch.displayName = 'CustomSwitch'

export default CustomSwitch
